//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from '../api/api.models'

import { BaseGridGridsterController, ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { ButtonsOptions } from '../common/grid/grid.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from '../common/details-popup/details-popup.directive'
import { ExportOptions } from '../common/export/'
import { GridController, GridTypes } from '../common/grid/grid.controller'
import { GridDetailsController } from '../common/grid-details/grid-details.directive.controller'
import { ImportOptions } from '../common/import/'
import { LoggerService } from './../common/common.module'
import { Map, MapButtonClass, MapOptions, MapButton } from '../common/map2/map.directive.controller'
import { TaskStatusChangeOptions, ITaskStatusChange } from './status-change/'

import { CommonHelper, EventsNames, LocalizationHelper, MapHelper, TypeHelper, ConvertHelper } from '../../helpers'
import { FilterNames } from '../../helpers/common-helper'

import { Activity, Enums } from '../../models/common'
import { OpBounds, OpPolygon, OpRange } from '../../models/custom/op-map-area'
import { OpTask, OpOperator } from '../../models/core'

import { GridContextMenuService } from '../../services/grid'
import { TaskService } from '../../services/task/task.service'
import { UserSessionService } from '../../services/user-session'
import { IMRBulkOperationInitializedArgs, IMRBulkOperationOptions, IIMRBulkOperation } from '../common/bulk-operation'
import { SystemService } from '../../services/system'
import { LogHelper } from '../../helpers/log-helper';
import { IMRConfirmationPopupInitializedArgs, IIMRConfirmationPopup, IMRConfirmationPopupOptions } from '../common/confirmation-popup2';
import { IIMRServiceman, IMRServicemanInitializedArgs, IMRServicemanOptions } from '../common/serviceman/serviceman.interfaces'


export interface TaskScope extends ScopeBaseGridsterGrid {
    deleteConfirmationOptions: {
        title: string
        onConfirmed: () => void
    }

    bulkDeleteOptions: IMRBulkOperationOptions<OpTask>

    statusChangeOptions: TaskStatusChangeOptions

    servicemanOptions: IMRServicemanOptions

}

export class TaskController extends BaseGridGridsterController {

    // #region Consts

    private get GRID_NAME() { return 'TasksGrid' }

    // #endregion


    // #region Members

    public confirmationPopupOptions: IMRConfirmationPopupOptions

    private bulkDelete: IIMRBulkOperation<OpTask>
    private confirmationPopup: IIMRConfirmationPopup
    private statusChange: ITaskStatusChange
    private grid: GridController<OpTask>
    private mapPolygons: OpPolygon[]
    private mapRanges: OpRange[]
    private rangesVisiblity: boolean = true
    private selectedFitterIds: any[]
    private fitters: OpOperator[]
    private serviceman: IIMRServiceman


    // #endregion


    // #region Ctor

    constructor(
        protected $scope: TaskScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        private gridContextMenuService: GridContextMenuService,
        private taskService: TaskService,
        protected systemService: SystemService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(
            $scope,
            $timeout,
            $state,
            userSession,
            systemService,
            api,
            localDictionary,
            null,
            GridDetailsController.getOptionsByReferenceType(Enums.ReferenceType.IdTask),
            Enums.SimaxModuleName[moduleName],
            referenceType,
            true
        )

        this.initialize()
    }

    // #endregion


    // #region Events

    private onInitialized(e: any, grid: GridController<OpTask>): void {
        this.grid = grid
        this.dataGrid = e.component
console.log(this.dataGrid)
        this.setGridId(e.tableId)
    }


    private onAdd(): void {
        const createEditInitParams: CreateEditInitParams = this.taskService.getCreateEditOptions()
        this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }

    private onEdit(): void {
        if (this.dataGrid.getSelectedRowKeys().length == 1) {
            const createEditInitParams: CreateEditInitParams = this.taskService.getCreateEditOptions(this.grid.selectedItemId)
            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        } else {
            const columnCount: number = this.dataGrid.columnCount()
            const columns: any[] = []

            for (let i = 0; i < columnCount; i++) {
                columns.push(this.dataGrid.columnOption(i))
            }

            const bulkEditInitParams: BulkEditInitParams = this.taskService.getBulkEditInitParams(TypeHelper.clone(this.grid.selectedGridItems, true), columns)

            this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onShowDetails(e: any): void {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId
        }

        this.showDetails(e, detailsOptions)
    }

    private onDelete(): void {
        if (_.size(this.grid.selectedItems) > 1) {
            this.setBulkDeleteConfirmationOptions()
            this.confirmationPopup.show()

        } else {
            this.setSingleDeleteConfirmationOptions()
            this.confirmationPopup.show()
        }
    }

    private onDeleted(): void {
        this.grid.dxGrid.refresh()
    }

    private onConfirmDelete(): void {
        if (_.size(this.grid.selectedItems) > 1) {

            if (this.$scope.bulkDeleteOptions != null) {
                this.bulkDelete.showPopup()
                this.bulkDelete.setDataSource(this.grid.selectedItems)
            } else {
                this.initializeBulkDelete(this.grid.selectedItems)
            }
        } else if (_.size(this.grid.selectedItems) === 1) {
            this.taskService
                .deleteTask(this.grid.selectedItem, true)
                .then(() => {
                    this.onDeleted()
                })
                .fail((error: any) => {
                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                    LogHelper.error(TaskService.LOG_PREFIX, errorMsg)
                })
        }
    }

    // #endregion

    //#region IMRConfirmationPopup

    private setConfirmationPopup(): void {
        this.confirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
            content: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            },

            onConfirmed: () => {
                this.onConfirmDelete()
            }
        }
    }

    //#endregion

    // #region IBulkDelete 

    private initializeBulkDelete(itemsToDelete: OpTask[]): void {
        this.$scope.bulkDeleteOptions = {
            operationMethod: (task: OpTask) => this.taskService.deleteTask(task),
            itemsToProcess: itemsToDelete,
            onInitialized: (e: IMRBulkOperationInitializedArgs<OpTask>) => this.onBulkDeleteInitialized(e),
            referenceType: Enums.ReferenceType.IdTask,
            onOperationFinished: () => this.onDeleted(),
            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BulkDelete)
        }
    }

    private onBulkDeleteInitialized(e: IMRBulkOperationInitializedArgs<OpTask>): void {
        this.bulkDelete = e.component
        this.bulkDelete.showPopup()
    }

    // #endregion

    // #region Setup

    private initialize(): void {
        this.setEvents()
        this.setStatusChangeOptions()
        this.setMainGridOptions()
        this.selectedFitterIds = this.taskService.getSavedFitterIds()
        this.setFittersMapElements()
        this.setConfirmationPopup()
        this.setServicemanOptions()
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,
            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_ADD) ? "['" + Activity[Activity.TASK_ADD] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DEL) ? "['" + Activity[Activity.TASK_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_EDIT) ? "['" + Activity[Activity.TASK_EDIT] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_LIST) ? "['" + Activity[Activity.TASK_LIST] + "']" : null,
            importPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_IMPORT_OP) ? "['" + Activity[Activity.TASK_IMPORT_OP] + "']" : null,
            exportPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_EXPORT_OP) ? "['" + Activity[Activity.TASK_EXPORT_OP] + "']" : null,

            onAddClick: () => this.onAdd(),
            onDeleteClick: () => this.onDelete(),
            onEditClick: () => this.onEdit(),
            onShowClick: (e: any) => this.onShowDetails(e),
            onShowMap: () => this.showMapDetails()
        }
    }

    private getImportOptions(): ImportOptions {
        return {
            dictionaryMethodName: null,
            popupName: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ImportTasks),
            requestMethodType: null,
            referenceType: this.referenceType,
            moduleName: this.moduleName,
            columnsReorderingDisabled: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskModuleMainGrid)
        }
    }

    private getExportOptions(): ExportOptions {
        return {
            referenceType: this.referenceType,
            pluginOptions: {
                moduleName: this.moduleName,
                popupName: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EXPORT, this.moduleName)
            }
        }
    }

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItemsByReferenceType(Enums.ReferenceType.IdTask, {
            idReferenceTypes: this.grid.selectedItemsIds,
            onEdit: () => this.onEdit(),
            showStatusChangePopup: () => this.showStatusChangePopup()
        })

        return this.mergeWithDefaultItems(isTouchScreen, items);
    }

    private showStatusChangePopup(): void {
        this.statusChange.open(this.grid.selectedItems)
    }

    private refreshFittersMapElements(): void {
        let mapPolygons: OpPolygon[] = []
        let mapRanges: OpRange[] = []

        _.forEach(this.fitters, (fitter: OpOperator) => {
            if (_.find(this.selectedFitterIds, (element: any) => element.id === fitter.idOperator) != null) {
                if (fitter.area != null) {

                    switch (fitter.area.type) {
                        case Enums.SimaxMapAreaType.Polygon:
                            mapPolygons.push(fitter.area as OpPolygon)
                            break

                        case Enums.SimaxMapAreaType.Range:
                            mapRanges.push(fitter.area as OpRange)

                            break
                    }
                }
            }
        })

        this.mapPolygons = mapPolygons
        this.mapRanges = MapHelper.setCustomApperiance(mapRanges)


        this.updatePolygonsAndRanges()
    }

    private setFittersMapElements(): void {
        if (this.userSession.getLoggedOperator().hasPermission(Activity.TASK_SHOW_FITTER_AREA_OP)) {
            this.userSession
                .getDataProvider()
                .Operator
                .getFitterOperators()
                .then((result: OpOperator[]) => {

                    this.fitters = result.filter((operator: OpOperator) => operator.area != null)
                    this.refreshFittersMapElements()
                })
        }
    }

    private setBulkDeleteConfirmationOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BulkDelete) + ` (${_.size(this.grid.selectedItems)})`,
            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setSingleDeleteConfirmationOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setStatusChangeOptions(): void {
        this.$scope.statusChangeOptions = {
            onInitialized: (statusChange: ITaskStatusChange) => this.statusChange = statusChange,
            onStatusChanged: () => this.grid.table.refresh(),
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted()
        )
        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions(): void {
        this.taskService
            .getMainGridColumns()
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.$scope.mainGridOptions = {
                    referenceId: this.referenceType,
                    idReferenceType: this.referenceType,
                    type: GridTypes.MAIN,
                    importOptions: this.getImportOptions(),
                    exportOptions: this.getExportOptions(),
                    name: this.GRID_NAME,
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    columnsDictionary: columns,
                    dataSourceAdditionalFields: null,
                    defaultColumnsDictionary: defaultColumns,
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.taskSaved,
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskModuleMainGrid),
                    getDataSourceMethod: this.userSession
                        .getDataProvider().Task.getTaskFilter,
                    onInitialized: (e: any, grid: GridController<OpTask>) => this.onInitialized(e, grid),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                    onSelectionChanged: (e: any) => this.onSelectionChanged(e),
                    onUpdateGridsterPosition: (e: any) => this.setGridsterPosition(e),
                    contextMenuItems: () => this.getContextMenuItems(),
                    dataSourceParser: this.taskService.getMainGridDataSourceParser(),
                    onDataReady: (data: any) => this.onDataReady(data)
                }
            })
    }

    private setServicemanOptions(): void {
        this.$scope.servicemanOptions = {
            onInitialized: (e: IMRServicemanInitializedArgs) => {
                this.serviceman = e.component
            },
            onServicemanRefreshed: (ids: number[]) => {
                this.selectedFitterIds = ids
                this.refreshFittersMapElements()
            }
        }
    }

    // #endregion

    // #region Map

    private updatePolygonsAndRanges(): void {
        this.getGridsterMap()
            .then((map: Map) => {
                if (this.rangesVisiblity) {
                    map.setPolygons(this.mapPolygons)
                    map.setRanges(this.mapRanges)
                }
                else {
                    map.setPolygons([])
                    map.setRanges([])
                }
            })
    }

    protected showMapDetails(): boolean {
        const result: boolean = super.showMapDetails()

        this.updatePolygonsAndRanges()

        return result
    }

    // #endregion


    // #region Map Events

    private onShowHideRangesClick(): void {
        this.rangesVisiblity = !this.rangesVisiblity

        this.updatePolygonsAndRanges()
    }

    private onShowServicemenPopupClick(): void {
        if (this.serviceman != null) {
            this.serviceman.show()
        }        
    }

    // #endregion


    // #region BaseGridGridsterController Implementation

    protected onGridsterMapConfiguration(mapOptions: MapOptions): void {
        mapOptions.enableAreaSelect = true

        mapOptions.onAreaSelect = (bounds: OpBounds) => {
            MapHelper
                .getCoordColumnNames(this.userSession.getDataProvider(), Enums.ReferenceType.IdTask)
                .then(([latColName, lonColName]: [string, string]) => {
                    this.addCustomGridFilter(CommonHelper.getLonLatFilter(bounds, latColName, lonColName, FilterNames.TasksByLocations))
                })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.TASK_SHOW_FITTER_AREA_OP)) {
            mapOptions.customButtons = this.getMapCustomButtons()
        }
    }


    private getMapCustomButtons(): MapButton[] {
        return [this.getServicemansButton(), this.getShowHideRangesButton()]
    }

    private getShowHideRangesButton(): MapButton {
        return {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowHideRanges),
            class: MapButtonClass.areaVisiblityButton,
            visible: true,
            onClick: () => this.onShowHideRangesClick()
        }
    }

    private getServicemansButton(): MapButton {
        return {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Servicemans),
            class: MapButtonClass.servicemansPopupButton,
            visible: true,
            onClick: () => this.onShowServicemenPopupClick()
        }
    }
    // #endregion

}
